<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>{{$t("reporter_information")}}</th>
        <th style="text-align: center">{{$t("reporting_reason")}}</th>
        <th style="text-align: center">{{$t("reporter_description")}}</th>
        <th style="text-align: center">{{$t("user_info")}}</th>
        <th style="text-align: center">{{$t("post")}}</th>
        <th style="text-align: center; justify-content: center">{{ $t('added_date') }}</th>
        <th style="text-align: center !important;">{{$t("actions")}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="user in users" :key="user._id">
        <td class="td-style">
          <router-link :to="'/users/detail/' + user.reporterDetails?.userId" class="name-row">
            <template v-if="user.reporterDetails.avatar">
              <div class="user-avatar-container">
                <img class="company-icon" :src="user.reporterDetails.avatar" />

                <span class="test-class">{{ user.reporterDetails.nickName }}</span>
              </div>
            </template>
            <template v-else>
              <em class="no-data-text">{{$t('no_data')}}</em>
            </template>
          </router-link>
        </td>
        <td class="td-style td-center">
            <span class="test-class">
              <span>
                {{ translatedReason(user.reason) }}
              </span>

            </span>
        </td>
        <td style="justify-items: center"  class="td-style">
          <div class="point-div">
            <span class="point-styling">{{truncateText(user.description,50)}}</span>
          </div>
        </td>
        <td class="td-style">
          <router-link :to="'/users/detail/' + user.post?.authorDetails?.userId" class="name-row">
            <template v-if="user.post?.authorDetails?.avatar">
              <div class="user-avatar-container">
                <img class="company-icon" :src="user.post?.authorDetails?.avatar" />

                <span class="test-class">{{ user.post?.authorDetails?.nickName }}</span>
              </div>
            </template>
            <template v-else>
              <em class="no-data-text">{{$t('no_data_found')}}</em>
            </template>
          </router-link>
        </td>

        <td style="justify-items: center"  class="td-style">
          <div class="point-div">
            <span class="point-styling">{{truncateText(user.post.content,50)}}</span>
          </div>
        </td>




        <td class="td-style td-center">
          <span class="test-class">{{formatDate(user.createdAt)}}</span>
        </td>


        <td style="justify-items: center" class="td-style td-center">
          <div class="user-avatar-container actions-container">
            <img src="@/assets/images/trash.svg" class="edit-icon" @click="showDeleteModal(user.post._id)"/>
          </div>

        </td>

      </tr>

      <tr v-else>
        <td colspan="8" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{ $t('loading') }}</span>
        </td>
      </tr>

      <tr v-if="!loading && users.length === 0 ">
        <td colspan="8" class="table-loading">
          <span class="text">{{$t("no_data_found")}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <ConfirmDeleteModal
      :isVisible="deleteModal.isVisible"
      :isLoading="deleteModal.isLoading"
      :title="$t('delete_post')"
      :message="$t('delete_post_confirm')"
      :onAction="confirmDeletePost"
      :onClose="closeDeleteModal"
  />
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {VueSpinner} from "vue3-spinners";
import GamificationFilters from "@/components/tables/Gamification/GamificationFilters.vue";
import userService from "@/service/userService";
import {handleErrorResponse} from "@/utils/utils";
import ActionDropdown from "@/components/ActionDropdown.vue";
import TableDownload from "@/components/TableDownload.vue";
import socialService from "../../../service/socialService";
import ConfirmDeleteModal from "@/components/modals/ConfirmDeleteModal.vue";

export default {
  components: {
    TableDownload,
    GamificationFilters,
    AddUserModal,
    ExpandableSearch,
    VueSpinner,
    ActionDropdown,
    ConfirmDeleteModal
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    users: {
      type: Array,
      required: true
    },
    rightAction: {
      type: Boolean,
      default: true
    },
    companyId:{
      type:Number,
      default:null
    },
    code: {
      type:Number,
      default:null
    },
    refreshData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      inviteCode: null,
      showModal: false,
      selectAll: false,
      showFilter: false,
      searchText: '',
      selectedUserIds: [],
      departmentList: [],
      departmentActions: [],
      isProcessing: false,
      deleteModal: {
        isVisible: false,
        isLoading: false,
        postIdToDelete: null
      }
    }
  },
  created() {
    this.inviteCode = this.code;
  },
  methods: {
    translatedReason(reason) {
      const currentLang = this.$i18n.locale;

      if (!reason) return '';

      if (currentLang === 'en') {
        return reason;
      }

      const reasonMap = {
        spam: 'SPAM',
        harassment: 'TACİZ',
        hate_speech: 'NEFRET SÖYLEMİ',
        inappropriate_content: 'UYGUNSUZ İÇERİK',
        violence: 'ŞİDDET',
        other: 'DİĞER',
      };

      return reasonMap[reason.toLowerCase()] || reason;
    },
    formatDate(dateStr) {
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return "-";
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return "-";
      }
    },
    toggleAll() {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        this.selectedUserIds = this.users.map(user => user.userId);
      } else {
        this.selectedUserIds = [];
      }
    },
    toggleUser(e, userId) {
      if (e.target.checked) {
        this.selectedUserIds.push(userId);
      } else {
        this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);
      }
    },
    handleSearch(event) {
      this.searchText = event.target.value;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    showDeleteModal(postId) {
      this.deleteModal.postIdToDelete = postId;
      this.deleteModal.isVisible = true;
    },
    closeDeleteModal() {
      this.deleteModal.isVisible = false;
      this.deleteModal.isLoading = false;
      this.deleteModal.postIdToDelete = null;
    },
    confirmDeletePost() {
      if (!this.deleteModal.postIdToDelete) return;

      this.deleteModal.isLoading = true;
      this.deletePost(this.deleteModal.postIdToDelete);
    },
    deletePost(postId) {
      socialService.deletePost(postId)
          .then(() => {
            this.$snackbar.add({
              text: this.$t('post_deleted_successfully'),
              type: 'success'
            });
            this.refreshData();
            this.closeDeleteModal();
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
            this.deleteModal.isLoading = false;
          });
    }
  }
}
</script>

<style scoped>
.point-div{
  padding: 4px 8px;
  background-color: #EBEDFB;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: auto;
}
.point-styling{
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #0E121B;
}

.flex-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.filter-view{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  min-height: 52px;
}
.company-icon {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}

.name-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.company-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
}

.no-data-text {
  font-style: italic;
  color: #B6C1DB;
  font-size: 12px;
  font-weight: bold;
}
.user-avatar-container{
  display: flex;
  position: relative;
  justify-items: center;
}
.edit-icon {
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
}
.table-title {
  font-size: 20px;
  color: #040C2D;
}
.td-style{
  align-content: center;
  text-align: center;
}

.td-center {
  text-align: center !important;
}

.actions-container {
  justify-content: center;
}

.content-table .header-table .trhead th:last-child {
  text-align: center !important;
  justify-content: center;
}
</style>
